import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'doctor';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const doctorActions = { ...slice.actions, ...extraActions };
export const doctorReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        doctor: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/doctor/list`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.doctor = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.doctor = action.payload;
            },
            [rejected]: (state, action) => {
                state.doctor = { error: action.error };
            }
        };
    }
}
